import React from 'react';
import styled from '@emotion/styled';
import { Text } from 'src/components';
import { colors } from 'src/theme';
import { Card } from './card';

const TextStyle = styled(Text)({
  textAlign: 'center'
})

export interface ActionLabelCardProps {
  text?: string;
}

export const ActionLabelCard: React.FC<ActionLabelCardProps> = ({ text }) => {
  if (!text) return null;
  return (
    <Card radius={4} padding={4} background={colors.success2}>
      <TextStyle type="tiny" color={colors.text3}>{text}</TextStyle>
    </Card>
  );
};